import { Stack, Typography } from '@mui/material';
import { TagsInput } from 'Components/HookFormInputs/TagsInput';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';

const TreatmentMethods = () => {
  const { treatmentMethods } = useContext(SuppliersContext);

  const { setValue, watch } = useFormContext<ITherapySuppliers>();

  const title =
    Dictionary[DICTIONARY.Suppliers].therapySearchForm.treatmentMethods;

  return treatmentMethods.resources && treatmentMethods.resources.length > 0 ? (
    <Stack
      gap='20px'
      sx={{
        '.MuiSvgIcon-root > path': {
          strokeWidth: '0.833333',
          stroke: '#A020FF',
        },
      }}
      component='fieldset'
    >
      <legend>{title}</legend>
      <Typography variant='body2'>{title}</Typography>
      <TagsInput
        filterTags={(treatmentMethods.resources || []).map((method) => ({
          label: method.content,
          value: method.resourceId,
        }))}
        isActive={(tag) => !!watch('treatMethod')?.find((t) => t === tag.value)}
        resetTags={() => {
          setValue('treatMethod', []);
        }}
        toggleFilter={(tag) => {
          let newTreatMethod = watch('treatMethod') || [];

          const tagIndex = newTreatMethod.findIndex((t) => t === tag.value);

          if (tagIndex === -1) newTreatMethod.push(tag.value);
          else newTreatMethod.splice(tagIndex, 1);

          setValue('treatMethod', newTreatMethod);
        }}
      />
    </Stack>
  ) : (
    <></>
  );
};

export default TreatmentMethods;
